import React from "react";
import {NormalLayout} from "../../../components/layouts/normal_layout";
import {Comparison} from "../../../components/products/hyperion/office/comparison";
import {Introduction} from "../../../components/products/hyperion/office/introduction";
import {Benefits} from "../../../components/products/hyperion/office/benefits";
import {Applications} from "../../../components/products/hyperion/office/applications";
import {SEO} from "../../../components/seo";

const Office: React.FC = () => {

  return (
    <NormalLayout type="product">
      <SEO title="Hyperion Office | UV Tech by Rendev" description="Hyperion Office | UV Tech by Rendev" />
      <Introduction />
      <Benefits />
      <Applications />
      <Comparison />
    </NormalLayout>
  )
}

export default Office;